import { render, staticRenderFns } from "./Under15ListDataTable.vue?vue&type=template&id=00c6603f&scoped=true"
import script from "./Under15ListDataTable.vue?vue&type=script&lang=js"
export * from "./Under15ListDataTable.vue?vue&type=script&lang=js"
import style0 from "./Under15ListDataTable.vue?vue&type=style&index=0&id=00c6603f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c6603f",
  null
  
)

export default component.exports